/*
 * Try with Mirra — trial quantity guard.
 *
 * The "Try with Mirra" product-page button is an APP block
 * (shopify://apps/try-with-mirra/.../try-with-mirra-product-button), so its
 * code is not part of this theme and cannot be edited here. On every click it
 * adds the product to the cart with its trial selling plan. Clicking it N times
 * either merges into one line with quantity N or creates N lines of the same
 * product — and because the cart hides the quantity stepper for any
 * selling-plan line, the customer can no longer bring it back down.
 *
 * A trial is one unit per product. This script enforces exactly that at the
 * cart level, regardless of the entry point: after any cart mutation it finds
 * lines carrying a "Mirra" trial selling plan and collapses each product down
 * to a single line of quantity 1 (extra duplicate lines are removed).
 *
 * Untouched: regular items, Appstle subscriptions, and the TBYB landing page
 * flow (which already adds each DIFFERENT trial product once at quantity 1).
 */
(function () {
  if (window.__mirraTrialQtyGuard) return;
  window.__mirraTrialQtyGuard = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  // A trial line is recognised the same way the rest of the theme does it:
  // the selling plan name contains "Mirra" (see appstle-bulk-qty.js, the cart
  // snippets and try-before-you-buy.liquid).
  function isMirraTrial(item) {
    var a = item && item.selling_plan_allocation;
    var name = a && a.selling_plan && a.selling_plan.name;
    return !!name && /mirra/i.test(name);
  }

  function sectionIds() {
    try {
      var h = window.Alpine && Alpine.store && Alpine.store('xCartHelper');
      if (h && typeof h.getSectionsToRender === 'function') {
        return h.getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (e) {}
    return [];
  }

  function reRender(data) {
    try {
      var h = window.Alpine && Alpine.store && Alpine.store('xCartHelper');
      if (h && typeof h.reRenderSections === 'function' && data && data.sections) {
        h.reRenderSections(data.sections);
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
  }

  async function enforce() {
    if (busy) return;
    busy = true;
    try {
      var cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); });

      // Group trial lines by variant so a product can occupy only one line.
      var byVariant = {};
      (cart.items || []).forEach(function (it) {
        if (!isMirraTrial(it)) return;
        var k = String(it.variant_id || it.id);
        (byVariant[k] = byVariant[k] || []).push(it);
      });

      var changes = [];
      Object.keys(byVariant).forEach(function (k) {
        byVariant[k].forEach(function (it, idx) {
          if (idx === 0) {
            if (it.quantity !== 1) changes.push({ id: it.key, quantity: 1 }); // cap to 1
          } else {
            changes.push({ id: it.key, quantity: 0 });                        // drop duplicate line
          }
        });
      });
      if (!changes.length) return;

      var ids = sectionIds();
      var last = null;
      for (var i = 0; i < changes.length; i++) {
        changes[i].sections = ids;
        last = await fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(changes[i])
        }).then(function (r) { return r.json(); });
      }
      reRender(last);
    } catch (e) {
      console.warn('[mirra-trial-guard]', e);
    } finally {
      busy = false;
    }
  }

  function schedule() { setTimeout(enforce, 60); }

  // Catch every cart mutation. The Mirra app button does its own add, so we
  // hook the two transports a storefront add-to-cart can use rather than
  // relying on a theme event the app may not dispatch.
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?/i.test(url)) {
        p.then(schedule).catch(function () {});
      }
      return p;
    };
  }

  var XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype && XHR.prototype.open) {
    var origOpen = XHR.prototype.open;
    XHR.prototype.open = function (method, url) {
      this.__mirraCartUrl = url || '';
      return origOpen.apply(this, arguments);
    };
    var origSend = XHR.prototype.send;
    XHR.prototype.send = function () {
      if (/\/cart\/(add|change|update|clear)(\.js)?/i.test(this.__mirraCartUrl || '')) {
        this.addEventListener('loadend', schedule);
      }
      return origSend.apply(this, arguments);
    };
  }

  // Sweep once on load to fix any cart that is already over the limit.
  if (document.readyState !== 'loading') enforce();
  else document.addEventListener('DOMContentLoaded', enforce);
})();
